export default __webpack_public_path__ + "static/media/TerminologyUsed.322ac9f7.pdf";